import {
  Flex,
  InputGroup,
  InputLeftAddon,
  NumberInput,
  NumberInputField,
  NumberInputProps,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper
} from '@chakra-ui/core'
import { ErrorMessage, FieldProps } from 'formik'
import * as React from 'react'
import { Text } from '../../Typography'
import { Label, LabelProps } from '../styles'
import { theme } from '../../../theme'

type ConnectedNumberInputProps = LabelProps &
  FieldProps &
  NumberInputProps & {
    label?: string
    unit: string
    precision?: number
  }

const ConnectedNumberInput: React.FC<ConnectedNumberInputProps> = ({
  label,
  field,
  placeholder,
  unit,
  precision,
  step,
  min,
  max,
  defaultValue,
  form,
  onChange,
  onBlur,
  isDisabled,
  ...rest
}) => (
  <Flex flexDirection="column" width="100%" mr={rest.mr} ml={rest.ml} mt={rest.mt} mb={rest.mb}>
    {label && <Label htmlFor={field.name}>{label}</Label>}
    <InputGroup width="100%">
      {!!unit && <InputLeftAddon>{unit}</InputLeftAddon>}
      <NumberInput
        width="100%"
        precision={precision}
        step={step || 1}
        min={min || 0}
        max={max || Number.MAX_SAFE_INTEGER}
        defaultValue={defaultValue}
        //@ts-ignore - onChange is there
        onChange={(value: number) => onChange || form.setFieldValue(field.name, value)}
        focusInputOnChange={false}
        isDisabled={isDisabled}
      >
        <NumberInputField
          onBlur={onBlur}
          id={field.name}
          roundedLeft={!!unit ? 0 : 4}
          focusBorderColor="brand.500"
          placeholder={placeholder || label}
        />
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </NumberInput>
    </InputGroup>
    <ErrorMessage name={field.name}>
      {(msg) => {
        return (
          <Text mt={2} color={theme.colors.error} textAlign="right">
            {msg}
          </Text>
        )
      }}
    </ErrorMessage>
  </Flex>
)

export default ConnectedNumberInput

ConnectedNumberInput.defaultProps = {
  mb: 2,
  fontWeight: 'lighter',
  precision: 0
}
